// import * as pcj from '../../../package.json';

export const environment = {
  production: true,
  baseUrl: 'https://api.livea.fr/',
  publicUrl: '',
  apiUrl: 'v1/',
  siteUrl: 'https://livea.fr/',
  carrierPalletMatrixApiPath: 'carrier-pallet-matrix',
  carrierSmallMatrixApiPath: 'carrier-small-matrix',
  carrierPalletMatrixAccessToken: 'CRfzvLC07VSFrEKfQIfpG5dhNAKjw2'
  // version: pcj.version,
};
